module.exports = __webpack_public_path__ + "img/h-page4-36.309eff57.png";